import { useParamHandler } from '@custom/dx3';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useHandleNavigate = () => {
  const navigate = useNavigate();

  const [redirParam] = useParamHandler('redirect', navigate);

  useEffect(() => {
    if (redirParam) navigate(redirParam, { replace: true });
  }, [redirParam, navigate]);
};
